import * as StringMask from "string-mask";
import { manterApenasLetrasENumerosEEspacos } from "@/utils/StringUtils.js";

export const aplicarMascara = (texto, padrao) => {
	const textoTratado = manterApenasLetrasENumerosEEspacos(texto);
	const resultado = StringMask.apply(textoTratado, padrao);
	// A lib de masks não bloqueia a digitação após o fim da máscara.
	// Deveria, né. Mas enfim, coloquei isso daqui para garantir que
	// depois da máscara, o texto não cresça;
	// ~Evandro
	return resultado.substring(0, padrao.length);
};

// Mesma coisa que o método de cima, porém não deixa caracteres especiais no final
export const aplicarMascaraExcetoFinal = (texto, padrao) => {
	let textoComMascara = aplicarMascara(texto, padrao);
	while(!"0123456789".includes(textoComMascara.slice(-1))){
		textoComMascara = textoComMascara.slice(0, -1);
	}
	return textoComMascara;
};
